import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../../apiService';

const Sixththeme = ({get_data = {}}) => {
    const navigate = useNavigate();
    const [cartCount, setCartCount] = useState(0);
    const [visibleCategories, setVisibleCategories] = useState(12);

    // Order Modal State
    const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [customerName, setCustomerName] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const [deliveryAddress, setDeliveryAddress] = useState('');
    const [orderNotes, setOrderNotes] = useState('');
    const [quantity, setQuantity] = useState(1);
    const [isSubmittingOrder, setIsSubmittingOrder] = useState(false);
    const [orderError, setOrderError] = useState(null);
    const [orderSuccess, setOrderSuccess] = useState(null);

    const handleOpenOrderModal = (item) => {
        setSelectedItem(item);
        setQuantity(1);
        setOrderError(null);
        setOrderSuccess(null);
        setIsOrderModalOpen(true);
    };

    const handleCloseOrderModal = () => {
        setIsOrderModalOpen(false);
        setOrderSuccess(null);
        setOrderError(null);
    };

    const handlePlaceOrder = async (e) => {
        if (e) e.preventDefault();
        if (!customerName.trim()) {
            setOrderError('Please enter your name.');
            return;
        }
        if (!customerPhone.trim() || customerPhone.trim().length < 10) {
            setOrderError('Please enter a valid 10-digit mobile number.');
            return;
        }
        if (!deliveryAddress.trim()) {
            setOrderError('Please enter your delivery or service address.');
            return;
        }

        setIsSubmittingOrder(true);
        setOrderError(null);

        const itemName = selectedItem?.service_name || selectedItem?.name || get_data.service_name || 'Service Order';
        const rawPrice = selectedItem?.price ? parseFloat(selectedItem.price) : 299;
        const totalPrice = (rawPrice * quantity).toFixed(2);
        const partnerId = get_data?.uploaded_by || 110;
        const partnerSlug = get_data?.slug || 'chandan-electronics';

        const payload = {
            slug: partnerSlug,
            partner_id: partnerId,
            customer_name: customerName.trim(),
            customer_phone: customerPhone.trim(),
            delivery_address: deliveryAddress.trim(),
            item_name: itemName,
            price: totalPrice,
            quantity: quantity,
            product_id: selectedItem?.id || 0,
            notes: orderNotes.trim()
        };

        try {
            const res = await apiService.submitPartnerStoreOrder(payload);
            if (res.data && res.data.status === 1) {
                setOrderSuccess({
                    booking_id: res.data.booking_id,
                    customer_name: customerName.trim(),
                    item_name: itemName,
                    price: totalPrice,
                    msg: res.data.msg || 'Order placed successfully!'
                });
            } else {
                setOrderError(res.data?.msg || 'Failed to place order. Please try again.');
            }
        } catch (err) {
            console.error('Order error:', err);
            setOrderError(err.response?.data?.msg || 'Failed to submit order. Please check network and try again.');
        } finally {
            setIsSubmittingOrder(false);
        }
    };

    React.useEffect(() => {
        const updateCount = () => {
            const storedCart = localStorage.getItem('cart');
            const cartItems = storedCart ? JSON.parse(storedCart) : [];
            const count = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
            setCartCount(count);
        };

        updateCount();
        window.addEventListener('storage', updateCount);
        window.addEventListener('cartUpdated', updateCount);

        return () => {
            window.removeEventListener('storage', updateCount);
            window.removeEventListener('cartUpdated', updateCount);
        };
    }, []);

    const [cart, setCart] = useState([]);

    const addToCart = (service) => {
        handleOpenOrderModal(service);
    };
    return (
        <>
            <style>{`
        :root {
            /* Palette: Industrial Trust */
            --primary: #003366;
            /* Deep Royal Blue */
            --primary-dark: #002244;
            --secondary: #f0f4f8;
            /* Light Blue-Gray */
            --accent: #ff6600;
            /* Safety Orange */
            --accent-hover: #e65c00;
            --text-dark: #121212;
            --text-gray: #555555;
            --white: #ffffff;

            --shadow-card: 0 4px 6px rgba(0, 0, 0, 0.1);
            --shadow-hover: 0 10px 15px rgba(0, 0, 0, 0.15);

            --font-head: 'Barlow', sans-serif;
            --font-body: 'Roboto', sans-serif;
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: var(--font-body);
            color: var(--text-dark);
            background-color: var(--white);
            line-height: 1.6;
        }

        h1,
        h2,
        h3,
        h4,
        h5 {
            font-family: var(--font-head);
            font-weight: 700;
            color: var(--primary);
            text-transform: uppercase;
            line-height: 1.1;
        }

        a {
            text-decoration: none;
            color: inherit;
            transition: 0.3s ease;
        }

        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
        }

        .section {
            padding: 80px 0;
        }

        /* Buttons */
        .btn {
            display: inline-block;
            padding: 14px 30px;
            background: var(--accent);
            color: var(--white);
            font-family: var(--font-head);
            font-weight: 700;
            text-transform: uppercase;
            border-radius: 4px;
            border: none;
            cursor: pointer;
            font-size: 1rem;
            transition: 0.3s;
        }

        .btn:hover {
            background: var(--accent-hover);
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(255, 102, 0, 0.3);
        }

        .btn-outline {
            background: transparent;
            border: 2px solid var(--white);
        }

        .btn-outline:hover {
            background: var(--white);
            color: var(--primary);
        }

        /* Action Buttons */
        .action-buttons {
            display: flex;
            gap: 10px;
            margin-top: 20px;
        }

        .btn-action {
            flex: 1;
            padding: 8px 10px;
            font-size: 0.8rem;
            text-transform: uppercase;
            font-weight: 700;
            cursor: pointer;
            transition: all 0.3s ease;
            text-align: center;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            text-decoration: none;
        }

        .btn-call {
            background-color: transparent;
            color: var(--text-dark);
            border: 1px solid var(--text-dark);
        }

        .btn-call:hover {
            background: var(--text-dark);
            color: var(--white);
        }

        .btn-enquiry {
            background-color: transparent;
            color: var(--primary);
            border: 1px solid var(--primary);
        }

        .btn-enquiry:hover {
            background: var(--primary);
            color: var(--white);
        }

        .btn-order {
            background: var(--accent);
            color: var(--white);
            border: 1px solid var(--accent);
        }

        .btn-order:hover {
            background: transparent;
            color: var(--accent);
        }

        /* Top Bar */
        .top-bar {
            background: var(--primary-dark);
            color: var(--white);
            padding: 10px 0;
            font-family: var(--font-head);
            font-size: 0.9rem;
            font-weight: 500;
        }

        .top-bar .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .top-info {
            display: flex;
            gap: 20px;
        }

        .top-info span {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .top-info svg {
            width: 16px;
            height: 16px;
            color: var(--accent);
        }

        /* Navbar */
        nav {
            background: var(--white);
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            padding: 15px 0;
            position: sticky;
            top: 0;
            z-index: 100;
        }

        nav .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .brand {
            font-family: var(--font-head);
            font-size: 2rem;
            font-weight: 800;
            color: var(--primary);
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .brand .icon-box {
            width: 40px;
            height: 40px;
            background: var(--accent);
            color: var(--white);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
        }

        .nav-menu {
            display: flex;
            gap: 30px;
            font-family: var(--font-head);
            font-weight: 600;
            text-transform: uppercase;
        }

        .nav-menu a:hover {
            color: var(--accent);
        }

        /* Hero Section */
        .hero {
            background: linear-gradient(rgba(0, 51, 102, 0.8), rgba(0, 51, 102, 0.8)), url('https://images.unsplash.com/photo-1581093588401-fbb62a02f120?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80');
            background-size: cover;
            background-position: center;
            height: 600px;
            display: flex;
            align-items: center;
            color: var(--white);
            text-align: center;
        }

        .hero-content {
            max-width: 800px;
            margin: 0 auto;
        }

        .hero h1 {
            color: var(--white);
            font-size: 4rem;
            margin-bottom: 20px;
            text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
        }

        .hero p {
            font-size: 1.25rem;
            margin-bottom: 30px;
            color: #e0e0e0;
        }

        .cta-group {
            display: flex;
            gap: 15px;
            justify-content: center;
        }

        /* About Section */
        .about-section {
            background: var(--white);
        }

        .section-title {
            text-align: center;
            margin-bottom: 50px;
        }

        .section-title span {
            color: var(--accent);
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 2px;
            display: block;
            margin-bottom: 10px;
        }

        .section-title h2 {
            font-size: 2.5rem;
        }

        .about-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 50px;
            align-items: center;
        }

        .about-features {
            display: grid;
            gap: 20px;
            margin-top: 30px;
        }

        .feature-item {
            display: flex;
            align-items: flex-start;
            gap: 15px;
        }

        .feature-icon {
            width: 50px;
            height: 50px;
            background: var(--secondary);
            color: var(--primary);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 5px;
            font-size: 1.5rem;
        }

        .feature-text h4 {
            margin-bottom: 5px;
            font-size: 1.1rem;
        }

        .feature-text p {
            font-size: 0.9rem;
            color: var(--text-gray);
        }

        /* Services Section */
        .services-section {
            background: var(--secondary);
        }

        .services-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 30px;
        }

        .service-card {
            background: var(--white);
            padding: 30px;
            border-bottom: 4px solid transparent;
            transition: 0.3s;
            box-shadow: var(--shadow-card);
        }

        .service-card:hover {
            border-bottom-color: var(--accent);
            transform: translateY(-5px);
            box-shadow: var(--shadow-hover);
        }

        .card-icon {
            width: 60px;
            height: 60px;
            background: var(--primary);
            color: var(--white);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.8rem;
            border-radius: 50%;
            margin-bottom: 20px;
        }

        .service-card h3 {
            margin-bottom: 15px;
        }

        .service-card p {
            color: var(--text-gray);
            margin-bottom: 20px;
        }

        .read-more {
            color: var(--accent);
            font-weight: 700;
            display: inline-flex;
            align-items: center;
            gap: 5px;
            font-size: 0.9rem;
        }

        /* Gallery/Projects */
        .gallery-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 10px;
        }

        .gallery-item {
            position: relative;
            height: 250px;
            overflow: hidden;
        }

        .gallery-item img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: 0.5s;
        }

        .gallery-item:hover img {
            transform: scale(1.1);
        }

        .overlay {
            position: absolute;
            inset: 0;
            background: rgba(0, 51, 102, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: 0.3s;
        }

        .gallery-item:hover .overlay {
            opacity: 1;
        }

        .overlay h4 {
            color: var(--white);
            border: 2px solid var(--accent);
            padding: 10px 20px;
        }

        /* Call To Action Strip */
        .cta-strip {
            background: var(--accent);
            color: var(--white);
            padding: 50px 0;
            text-align: center;
        }

        .cta-strip h2 {
            color: var(--white);
            font-size: 2.5rem;
            margin-bottom: 10px;
        }

        /* Footer */
        footer {
            background: #111;
            color: #aaa;
            padding: 60px 0 20px;
        }

        .footer-grid {
            display: grid;
            grid-template-columns: 1.5fr 1fr 1fr 1fr;
            gap: 40px;
            margin-bottom: 40px;
        }

        .footer-col h4 {
            color: var(--white);
            margin-bottom: 20px;
        }

        .footer-col p {
            margin-bottom: 15px;
        }

        .footer-links li {
            list-style: none;
            margin-bottom: 10px;
        }

        .footer-links a:hover {
            color: var(--accent);
        }

        .footer-bottom {
            border-top: 1px solid #333;
            padding-top: 20px;
            text-align: center;
            font-size: 0.9rem;
        }

        /* Responsive */
        @media (max-width: 900px) {
            .hero h1 {
                font-size: 2.5rem;
            }

            .about-grid {
                grid-template-columns: 1fr;
            }

            .services-grid {
                grid-template-columns: repeat(2, 1fr);
            }

            .gallery-grid {
                grid-template-columns: repeat(2, 1fr);
            }
        }

        @media (max-width: 600px) {
            .top-bar {
                display: none;
            }

            .nav-menu {
                display: none;
            }

            /* Hide for demo */
            .services-grid {
                grid-template-columns: 1fr;
            }

            .gallery-grid {
                grid-template-columns: 1fr;
            }

            .footer-grid {
                grid-template-columns: 1fr;
            }
        }
    `}</style>
            
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
            <link
                href="https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;600;700;800&family=Roboto:wght@400;500;700&display=swap"
                rel="stylesheet" />

            {/* Top Bar */}
            <div className="top-bar">
                <div className="container">
                    <div className="top-info">
                        {get_data.email && (
                            <span>
                                <svg fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                </svg>
                                {get_data.email}
                            </span>
                        )}
                        {get_data.mobile && (
                            <span>
                                <svg fill="currentColor" viewBox="0 0 20 20">
                                    <path
                                        d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                </svg>
                                Hotline: {get_data.mobile}
                            </span>
                        )}
                    </div>
                    {get_data.business_location_name && (
                         <div className="top-info">
                            <span>Serving {get_data.business_location_name}</span>
                        </div>
                    )}
                </div>
            </div>

            {/* Navigation */}
            <nav>
                <div className="container">
                    <a href="#" className="brand">
                        <div className="icon-box">⚙</div>
                        {get_data.service_name}
                    </a>
                    <ul className="nav-menu">
                        <li><a href="#">Home</a></li>
                        <li><a href="#about">About</a></li>
                        <li><a href="#services">Services</a></li>
                        <li><a href="#products">Products</a></li>
                        <li><a href="#contact">Contact</a>
                        <a href="/cart" style={{display: 'flex', alignItems: 'center', position: 'relative', marginLeft: '15px', color: 'inherit', textDecoration: 'none'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            </svg>
                            {cartCount > 0 && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-10px',
                                    background: 'red',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.7rem',
                                    fontWeight: 'bold'
                                }}>
                                    {cartCount}
                                </span>
                            )}
                        </a></li>
                    </ul>
                </div>
            </nav>

            {/* Hero */}
            <header className="hero">
                <div className="container">
                    <div className="hero-content">
                        <h1>Professional Repair Services You Can Trust</h1>
                        <p>Fast, reliable, and affordable solutions for all your home and office maintenance needs. We fix it
                            right, the first time.</p>
                        <div className="cta-group">
                            <button 
                                onClick={() => handleOpenOrderModal({
                                    service_name: get_data.service_name ? `${get_data.service_name} Service` : 'General Service',
                                    price: 299,
                                    id: 0,
                                    description: 'On-demand doorstep repair & maintenance service'
                                })} 
                                className="btn"
                            >
                                Book Service Now
                            </button>
                            <button className="btn btn-outline" style={{borderColor: '#fff', color: '#fff'}}>Our Services</button>
                        </div>
                    </div>
                </div>
            </header>

            {/* About */}
            <section className="section about-section" id="about">
                <div className="container">
                    <div className="about-grid">
                        <div>
                            <img src="https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
                                alt="Worker" style={{width: '100%', borderRadius: '4px', boxShadow: '0 10px 20px rgba(0,0,0,0.1)'}} />
                        </div>
                        <div>
                            <div className="section-title" style={{textAlign: 'left', marginBottom: '20px'}}>
                                <span>Who We Are</span>
                                <h2>Experts in Repair & Maintenance</h2>
                            </div>
                            <p style={{color: '#666', marginBottom: '20px'}}>For over 15 years, ProFix Masters has been the go-to
                                provider for emergency repairs and routine maintenance. Our team of certified technicians is
                                dedicated to delivering top-notch service with a focus on safety and integrity.</p>

                            <div className="about-features">
                                <div className="feature-item">
                                    <div className="feature-icon">✓</div>
                                    <div className="feature-text">
                                        <h4>Licensed & Insured</h4>
                                        <p>Fully accredited professionals for your peace of mind.</p>
                                    </div>
                                </div>
                                <div className="feature-item">
                                    <div className="feature-icon">⚡</div>
                                    <div className="feature-text">
                                        <h4>Fast Response Time</h4>
                                        <p>We arrive quickly to minimize downtime and inconvenience.</p>
                                    </div>
                                </div>
                                <div className="feature-item">
                                    <div className="feature-icon">$</div>
                                    <div className="feature-text">
                                        <h4>Upfront Pricing</h4>
                                        <p>No hidden fees. You approve the price before we start.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services */}
            <section className="section services-section" id="services">
                <div className="container">
                    <div className="section-title">
                        <span>What We Do</span>
                        <h2>Our Premium Services</h2>
                    </div>
                    <div className="services-grid">
                        {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((item, index) => (
                            <div className="service-card" key={index}>
                                <div className="card-icon" style={{overflow: 'hidden', borderRadius: '50%'}}>
                                     {item.icon ? (
                                         <img 
                                            src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} 
                                            alt={item.name}
                                            style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                        />
                                    ) : (
                                        <span>⚙</span>
                                    )}
                                </div>
                                <h3>{item.name}</h3>
                                <p>{item.description || 'Professional service description available upon request.'}</p>
                                <div className="action-buttons">
                                    <button 
                                        onClick={() => handleOpenOrderModal({
                                            name: item.name,
                                            service_name: item.name,
                                            price: item.price || 199,
                                            id: item.id || 0,
                                            description: item.description,
                                            featured_image: item.icon
                                        })} 
                                        className="btn-action btn-order"
                                    >
                                        Order
                                    </button>
                                    <a href={`tel:${get_data.mobile}`} className="btn-action btn-call">
                                        Call
                                    </a>
                                    <a href="#contact" className="btn-action btn-enquiry">
                                        Enquiry
                                    </a>
                                </div>
                            </div>
                        )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                    </div>
                </div>
            </section>

            {/* Products */}
            <section className="section services-section" id="products" style={{backgroundColor: 'var(--white)'}}>
                <div className="container">
                    <div className="section-title">
                        <span>Our Inventory</span>
                        <h2>Quality Products</h2>
                    </div>
                    <div className="services-grid">
                        {get_data.product_services && get_data.product_services.map((item, index) => (
                            <div className="service-card" key={index} style={{backgroundColor: 'var(--secondary)'}}>
                                <div style={{width: '100%', height: '200px', marginBottom: '20px', borderRadius: '4px', overflow: 'hidden'}}>
                                    {item.featured_image ? (
                                         <img 
                                            src={item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} 
                                            alt={item.service_name}
                                            style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                        />
                                    ) : (
                                        <div style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ddd', color: '#888'}}>
                                            No Image
                                        </div>
                                    )}
                                </div>
                                <h3>{item.service_name}</h3>
                                <p style={{color: 'var(--accent)', fontWeight: 'bold', fontSize: '1.1rem', marginBottom: '10px'}}>
                                    {item.price ? `₹${item.price}` : 'Contact for Price'}
                                </p>
                                <p>{item.description || 'Quality product available for order.'}</p>
                                <div className="action-buttons">
                                     <button onClick={() => addToCart(item)} className="btn-action btn-order">
                                        Order
                                    </button>
                                    <a href={`tel:${get_data.mobile}`} className="btn-action btn-call">
                                        Call
                                    </a>
                                    <a href="#contact" className="btn-action btn-enquiry">
                                        Enquiry
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Strip */}
            <div className="cta-strip">
                <div className="container">
                    <h2>Need Emergency Assistance?</h2>
                    <p style={{fontSize: '1.2rem', marginBottom: '20px'}}>Our support team is available 24 hours a day, 7 days a
                        week.</p>
                    <a href={`tel:${get_data.mobile}`} className="btn" style={{background: '#fff', color: 'var(--accent)', textDecoration: 'none'}}>Call {get_data.mobile || '(555) 987-6543'}</a>
                </div>
            </div>


            {/* Browse Categories Section */}
            <section className="section dedicated-categories" style={{padding: '50px 0', background: '#f9f9f9'}}>
                <div className="container">
                    <div style={{textAlign: 'center', marginBottom: '40px'}}>
                        <h2 style={{fontSize: '2rem', marginBottom: '10px', color: '#333'}}>Browse Categories</h2>
                    </div>
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px'}}>
                        {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((cat, index) => (
                            <div key={index} style={{background: '#fff', padding: '20px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', textAlign: 'center'}}>
                                {cat.icon ? (
                                    <img src={cat.icon.startsWith('http') ? cat.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${cat.icon}`} 
                                         style={{width: '60px', height: '60px', objectFit: 'contain', marginBottom: '15px'}} alt={cat.name} />
                                ) : (
                                    <div style={{width: '60px', height: '60px', background: '#eee', borderRadius: '50%', margin: '0 auto 15px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold'}}>
                                        {(cat.name || 'C').charAt(0)}
                                    </div>
                                )}
                                <h3 style={{fontSize: '1.1rem', marginBottom: '15px', color: '#333'}}>{cat.name}</h3>
                                <div style={{display: 'flex', gap: '10px'}}>
                                    <a href={`tel:${get_data.mobile}`} style={{flex: 1, padding: '8px', border: '1px solid currentColor', borderRadius: '4px', textDecoration: 'none', color: '#333', fontSize: '0.9rem'}}>Call</a>
                                    <a href="#contact" style={{flex: 1, padding: '8px', background: '#007bff', color: '#fff', borderRadius: '4px', textDecoration: 'none', fontSize: '0.9rem'}}>Enquiry</a>
                                </div>
                            </div>
                        )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                    </div>
                </div>
            </section>

            {/* Testimonials */}
            <section className="section" id="reviews" style={{backgroundColor: 'var(--secondary)'}}>
                <div className="container">
                    <div className="section-title">
                        <span>Testimonials</span>
                        <h2>What Our Customers Say</h2>
                    </div>
                    {get_data.review_ratings && get_data.review_ratings.length > 0 ? (
                        <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '30px'}}>
                            {get_data.review_ratings.map((review, index) => (
                                <div key={index}
                                    style={{background: 'var(--white)', padding: '30px', borderRadius: '4px', borderTop: '4px solid var(--accent)', boxShadow: 'var(--shadow-card)'}}>
                                    {review.rating && (
                                        <div style={{color: '#ffb400', fontSize: '1.2rem', marginBottom: '15px'}}>
                                            {'★'.repeat(Math.round(review.rating)) + '☆'.repeat(5 - Math.round(review.rating))}
                                        </div>
                                    )}
                                    <p style={{fontStyle: 'italic', color: 'var(--text-gray)', marginBottom: '20px'}}>
                                        "{review.review || 'No review detail provided.'}"</p>
                                    <h4 style={{fontSize: '1rem'}}>{review.user_name || 'Valued Customer'}</h4>
                                    <span style={{fontSize: '0.85rem', color: '#888'}}>Verified Client</span>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div style={{textAlign: 'center', padding: '40px', color: 'var(--text-gray)', fontStyle: 'italic'}}>
                            <p>No reviews yet.</p>
                        </div>
                    )}
                </div>
            </section>

            {/* Footer */}
            <footer id="contact">
                <div className="container">
                    <div className="footer-grid">
                        <div className="footer-col">
                            <div className="brand" style={{color: '#fff', marginBottom: '20px'}}>
                                <div className="icon-box" style={{background: 'var(--accent)'}}>⚙</div>
                                {get_data.service_name || 'Partner Store'}
                            </div>
                            <p>We provide guaranteed quality workmanship for all your residential and commercial needs.</p>
                        </div>
                        <div className="footer-col" style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                            <h4>Connect</h4>
                            {get_data.instagram && <a href={get_data.instagram} style={{color: '#aaa', textDecoration: 'none'}}>Instagram</a>}
                            {get_data.facebook && <a href={get_data.facebook} style={{color: '#aaa', textDecoration: 'none'}}>Facebook</a>}
                            {get_data.youtube && <a href={get_data.youtube} style={{color: '#aaa', textDecoration: 'none'}}>Youtube</a>}
                            {get_data.twitter && <a href={get_data.twitter} style={{color: '#aaa', textDecoration: 'none'}}>Twitter</a>}
                        </div>
                        <div className="footer-col">
                            <h4>Services</h4>
                            <ul className="footer-links">
                                <li><a href="#services">All Services</a></li>
                                <li><a href="#products">Products</a></li>
                            </ul>
                        </div>
                        <div className="footer-col">
                            <h4>Contact Info</h4>
                            <p>{get_data.business_location_name}</p>
                            <p>Email: {get_data.email}</p>
                            <p>Phone: {get_data.mobile}</p>
                        </div>
                    </div>
                    <div className="footer-bottom">
                         &copy; {new Date().getFullYear()} {get_data.service_name || 'Partner Store'}. All Rights Reserved.
                    </div>
                </div>
            </footer>

            {/* Interactive Order Modal */}
            {isOrderModalOpen && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.65)',
                    backdropFilter: 'blur(4px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 99999,
                    padding: '16px'
                }}>
                    <div style={{
                        background: '#ffffff',
                        borderRadius: '16px',
                        width: '100%',
                        maxWidth: '520px',
                        maxHeight: '92vh',
                        overflowY: 'auto',
                        boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                        position: 'relative',
                        animation: 'fadeInUp 0.25s ease-out',
                        fontFamily: 'var(--font-body)'
                    }}>
                        {/* Modal Header */}
                        <div style={{
                            background: 'linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%)',
                            color: '#fff',
                            padding: '18px 22px',
                            borderTopLeftRadius: '16px',
                            borderTopRightRadius: '16px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div>
                                <h3 style={{color: '#fff', margin: 0, fontSize: '1.25rem', letterSpacing: '0.5px'}}>
                                    {orderSuccess ? 'Order Placed!' : 'Place Your Order'}
                                </h3>
                                <p style={{margin: '4px 0 0', fontSize: '0.85rem', color: '#cfe2f3'}}>
                                    {get_data.service_name || 'Partner Store'}
                                </p>
                            </div>
                            <button 
                                onClick={handleCloseOrderModal}
                                style={{
                                    background: 'rgba(255,255,255,0.18)',
                                    border: 'none',
                                    color: '#fff',
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '50%',
                                    cursor: 'pointer',
                                    fontSize: '1.1rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                ✕
                            </button>
                        </div>

                        {/* Modal Content */}
                        <div style={{padding: '22px'}}>
                            {orderSuccess ? (
                                <div style={{textAlign: 'center', padding: '10px 0'}}>
                                    <div style={{
                                        width: '72px',
                                        height: '72px',
                                        borderRadius: '50%',
                                        background: '#e6f7ea',
                                        color: '#28a745',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '2.5rem',
                                        margin: '0 auto 16px',
                                        boxShadow: '0 4px 12px rgba(40,167,69,0.2)'
                                    }}>
                                        ✓
                                    </div>
                                    <h4 style={{fontSize: '1.4rem', color: '#1a1a1a', marginBottom: '8px'}}>Order Confirmed!</h4>
                                    <p style={{color: '#555', fontSize: '0.95rem', marginBottom: '20px'}}>
                                        {orderSuccess.msg}
                                    </p>

                                    <div style={{
                                        background: '#f8fafc',
                                        border: '1px solid #e2e8f0',
                                        borderRadius: '12px',
                                        padding: '16px',
                                        marginBottom: '20px',
                                        textAlign: 'left'
                                    }}>
                                        <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '10px', borderBottom: '1px solid #edf2f7', paddingBottom: '8px'}}>
                                            <span style={{color: '#718096', fontSize: '0.9rem'}}>Booking / Order ID:</span>
                                            <strong style={{color: 'var(--accent)', fontSize: '1.05rem'}}>#{orderSuccess.booking_id}</strong>
                                        </div>
                                        <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '10px', borderBottom: '1px solid #edf2f7', paddingBottom: '8px'}}>
                                            <span style={{color: '#718096', fontSize: '0.9rem'}}>Item:</span>
                                            <strong style={{color: '#2d3748', fontSize: '0.9rem'}}>{orderSuccess.item_name}</strong>
                                        </div>
                                        <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '10px', borderBottom: '1px solid #edf2f7', paddingBottom: '8px'}}>
                                            <span style={{color: '#718096', fontSize: '0.9rem'}}>Customer Name:</span>
                                            <strong style={{color: '#2d3748', fontSize: '0.9rem'}}>{orderSuccess.customer_name}</strong>
                                        </div>
                                        <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                            <span style={{color: '#718096', fontSize: '0.9rem'}}>Total Amount:</span>
                                            <strong style={{color: '#28a745', fontSize: '1.15rem'}}>₹{orderSuccess.price}</strong>
                                        </div>
                                    </div>

                                    <div style={{
                                        background: '#e8f4fd',
                                        borderRadius: '8px',
                                        padding: '12px',
                                        marginBottom: '20px',
                                        color: '#00529b',
                                        fontSize: '0.85rem'
                                    }}>
                                        ✓ This order has been sent directly to the partner. You can view this order immediately in the Partner Orders dashboard at <code>localhost:8100/orders</code>.
                                    </div>

                                    <button
                                        onClick={handleCloseOrderModal}
                                        style={{
                                            width: '100%',
                                            padding: '14px',
                                            background: 'var(--primary)',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '8px',
                                            fontWeight: 600,
                                            fontSize: '1rem',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Close
                                    </button>
                                </div>
                            ) : (
                                <form onSubmit={handlePlaceOrder}>
                                    {/* Item Summary Card */}
                                    <div style={{
                                        background: '#f8fafc',
                                        border: '1px solid #e2e8f0',
                                        borderRadius: '12px',
                                        padding: '14px 16px',
                                        marginBottom: '18px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between'
                                    }}>
                                        <div>
                                            <h4 style={{margin: 0, fontSize: '0.98rem', color: 'var(--primary)'}}>
                                                {selectedItem?.service_name || selectedItem?.name || get_data.service_name || 'Store Item'}
                                            </h4>
                                            <span style={{fontSize: '0.85rem', color: 'var(--accent)', fontWeight: 600}}>
                                                ₹{selectedItem?.price ? selectedItem.price : 299} each
                                            </span>
                                        </div>
                                        
                                        {/* Quantity Controls */}
                                        <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                            <button
                                                type="button"
                                                onClick={() => setQuantity(Math.max(1, quantity - 1))}
                                                style={{
                                                    width: '28px',
                                                    height: '28px',
                                                    borderRadius: '4px',
                                                    border: '1px solid #cbd5e1',
                                                    background: '#fff',
                                                    cursor: 'pointer',
                                                    fontSize: '1rem',
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                -
                                            </button>
                                            <span style={{fontWeight: 600, minWidth: '22px', textAlign: 'center'}}>
                                                {quantity}
                                            </span>
                                            <button
                                                type="button"
                                                onClick={() => setQuantity(quantity + 1)}
                                                style={{
                                                    width: '28px',
                                                    height: '28px',
                                                    borderRadius: '4px',
                                                    border: '1px solid #cbd5e1',
                                                    background: '#fff',
                                                    cursor: 'pointer',
                                                    fontSize: '1rem',
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                +
                                            </button>
                                        </div>
                                    </div>

                                    {orderError && (
                                        <div style={{
                                            background: '#ffebee',
                                            borderLeft: '4px solid #f44336',
                                            color: '#c62828',
                                            padding: '10px 14px',
                                            borderRadius: '4px',
                                            fontSize: '0.875rem',
                                            marginBottom: '16px'
                                        }}>
                                            {orderError}
                                        </div>
                                    )}

                                    {/* Form Fields */}
                                    <div style={{marginBottom: '14px'}}>
                                        <label style={{display: 'block', fontSize: '0.85rem', fontWeight: 600, color: '#334155', marginBottom: '6px'}}>
                                            Full Name *
                                        </label>
                                        <input
                                            type="text"
                                            value={customerName}
                                            onChange={(e) => setCustomerName(e.target.value)}
                                            placeholder="Enter your full name"
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '10px 14px',
                                                borderRadius: '8px',
                                                border: '1px solid #cbd5e1',
                                                fontSize: '0.95rem',
                                                boxSizing: 'border-box',
                                                outline: 'none'
                                            }}
                                        />
                                    </div>

                                    <div style={{marginBottom: '14px'}}>
                                        <label style={{display: 'block', fontSize: '0.85rem', fontWeight: 600, color: '#334155', marginBottom: '6px'}}>
                                            Mobile / WhatsApp Number *
                                        </label>
                                        <input
                                            type="tel"
                                            value={customerPhone}
                                            onChange={(e) => setCustomerPhone(e.target.value)}
                                            placeholder="10-digit mobile number"
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '10px 14px',
                                                borderRadius: '8px',
                                                border: '1px solid #cbd5e1',
                                                fontSize: '0.95rem',
                                                boxSizing: 'border-box',
                                                outline: 'none'
                                            }}
                                        />
                                    </div>

                                    <div style={{marginBottom: '14px'}}>
                                        <label style={{display: 'block', fontSize: '0.85rem', fontWeight: 600, color: '#334155', marginBottom: '6px'}}>
                                            Delivery / Service Address *
                                        </label>
                                        <textarea
                                            value={deliveryAddress}
                                            onChange={(e) => setDeliveryAddress(e.target.value)}
                                            placeholder="House / Flat No., Street, Area, Landmark, City"
                                            rows="2"
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '10px 14px',
                                                borderRadius: '8px',
                                                border: '1px solid #cbd5e1',
                                                fontSize: '0.95rem',
                                                boxSizing: 'border-box',
                                                outline: 'none',
                                                resize: 'vertical'
                                            }}
                                        />
                                    </div>

                                    <div style={{marginBottom: '18px'}}>
                                        <label style={{display: 'block', fontSize: '0.85rem', fontWeight: 600, color: '#334155', marginBottom: '6px'}}>
                                            Order Notes / Instructions (Optional)
                                        </label>
                                        <input
                                            type="text"
                                            value={orderNotes}
                                            onChange={(e) => setOrderNotes(e.target.value)}
                                            placeholder="e.g. Call before delivery, morning visit prefered"
                                            style={{
                                                width: '100%',
                                                padding: '10px 14px',
                                                borderRadius: '8px',
                                                border: '1px solid #cbd5e1',
                                                fontSize: '0.95rem',
                                                boxSizing: 'border-box',
                                                outline: 'none'
                                            }}
                                        />
                                    </div>

                                    {/* Total Payable */}
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '12px 0',
                                        borderTop: '1px dashed #cbd5e1',
                                        marginBottom: '18px'
                                    }}>
                                        <span style={{fontWeight: 600, color: '#334155'}}>Total Amount:</span>
                                        <span style={{fontSize: '1.25rem', fontWeight: 700, color: 'var(--accent)'}}>
                                            ₹{((selectedItem?.price ? parseFloat(selectedItem.price) : 299) * quantity).toFixed(2)}
                                        </span>
                                    </div>

                                    <div style={{display: 'flex', gap: '12px'}}>
                                        <button
                                            type="button"
                                            onClick={handleCloseOrderModal}
                                            disabled={isSubmittingOrder}
                                            style={{
                                                flex: 1,
                                                padding: '12px',
                                                borderRadius: '8px',
                                                border: '1px solid #cbd5e1',
                                                background: '#f1f5f9',
                                                color: '#475569',
                                                fontWeight: 600,
                                                cursor: 'pointer'
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            disabled={isSubmittingOrder}
                                            style={{
                                                flex: 2,
                                                padding: '12px',
                                                borderRadius: '8px',
                                                border: 'none',
                                                background: isSubmittingOrder ? '#94a3b8' : 'var(--accent)',
                                                color: '#fff',
                                                fontWeight: 700,
                                                fontSize: '1rem',
                                                cursor: isSubmittingOrder ? 'not-allowed' : 'pointer',
                                                boxShadow: '0 4px 12px rgba(255,102,0,0.3)'
                                            }}
                                        >
                                            {isSubmittingOrder ? 'Submitting Order...' : 'Confirm Order'}
                                        </button>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default Sixththeme
